import { z } from 'zod'

/** How a recognized AI app is identified: its client ID metadata URL, or an exact redirect URI. */
export const RECOGNIZED_APP_MATCHES = ['client_id_url', 'redirect_uri'] as const

export const recognizedAppMatchSchema = z.enum(RECOGNIZED_APP_MATCHES)

export type RecognizedAppMatch = z.infer<typeof recognizedAppMatchSchema>

export const PRISMA_RECOGNIZED_APP_MATCHES = ['CLIENT_ID_URL', 'REDIRECT_URI'] as const

export type PrismaRecognizedAppMatch = (typeof PRISMA_RECOGNIZED_APP_MATCHES)[number]

export const RECOGNIZED_APP_MATCH_FROM_PRISMA = {
  CLIENT_ID_URL: 'client_id_url',
  REDIRECT_URI: 'redirect_uri',
} as const satisfies Record<PrismaRecognizedAppMatch, RecognizedAppMatch>

export const RECOGNIZED_APP_MATCH_TO_PRISMA = {
  client_id_url: 'CLIENT_ID_URL',
  redirect_uri: 'REDIRECT_URI',
} as const satisfies Record<RecognizedAppMatch, PrismaRecognizedAppMatch>
